"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegacyTimelineDetails = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getLegacyTimelineDetails = (0, sonar_http_1.createGetEndpoint)((request) => `/api/v2/Timelines/details?${(0, sonar_http_1.getQueryString)(request)}`);
//# sourceMappingURL=getLegacyTimelineDetails.js.map